import { apiList, $axios } from '@/api'

export default {
    actions: {
        getCourseUserBadges(_, payload) {
            return new Promise((resolve, reject) => {
                $axios({
                    method: apiList.badges.getUserBadges.method,
                    params: {
                        wsfunction: apiList.badges.getUserBadges.moodle_method,
                        courseid: payload?.course || undefined,
                        userid: payload?.id || undefined,
                        search: payload.search || undefined
                    }
                })
                    .then(resp => {
                        resolve(resp.data)
                    }).catch(err => reject(err))
            })
        }
    }
}
